export default "__VITE_ASSET__CyrwUoOR__"